<template>
    <div class="g-pop-box" v-if="popGiftList.length">
        <div v-for="item in popGiftList">
            <!--正在进行中整点加赠 -->
            <OnTheHour :timeGift="item.normalList" class="g-pop-item" v-if="item.giftType==43&&item.normalList[0].hourGiftFlag==1" />
            <!-- 权益赠品 -->
            <BenefitGifts :giftList="item.normalList"  v-else-if="item.giftType==45">
                <template v-slot:benefitGiftsOptional  v-if="item.opList&&item.opList.length">
                    <OptionalGifts :list="item.opList" :optionalGiftId="item.optionalGiftId" :selectNums="item.opList[0].allOpCount" :skuId="skuId" @select="handleGiftSelect"></OptionalGifts>
                </template>
            </BenefitGifts>
            <!-- 会员加赠 -->
            <VipGifts :giftList="item.normalList" v-else-if="item.giftType==42">
                <template v-slot:vipGiftsOptional v-if="item.opList&&item.opList.length">
                    <OptionalGifts :list="item.opList" :optionalGiftId="item.optionalGiftId" :selectNums="item.opList[0].allOpCount" :skuId="skuId" @select="handleGiftSelect"></OptionalGifts>
                </template>
            </VipGifts>
            <!--下一场未开始整点加赠预告，没有正在进行中的才展示，否则隐藏，待到开始时间再刷新 -->
            <OnTheHour :timeGift="item.normalList" class="g-pop-item" v-else-if="item.giftType==43&&item.normalList[0].hourGiftFlag!=1" />
            <NormalGifts :giftList="item.normalList" v-else>
                <template v-slot:normalGiftsOptional v-if="item.opList&&item.opList.length">
                    <OptionalGifts :list="item.opList" :optionalGiftId="item.optionalGiftId" :selectNums="item.opList[0].allOpCount" :skuId="skuId" @select="handleGiftSelect"></OptionalGifts>
                </template>
            </NormalGifts>
        </div>
    </div>
</template>
<script>
import OnTheHour from './component/on-the-hour'
import GiveawayPopItem from './component/giveaway-pop-item'
import OptionalGifts from './component/optional-gifts'
import BenefitGifts from './component/benefit-gifts'
import NormalGifts from './component/normal-gifts'
import VipGifts from './component/vip-gifts'

export default {
    name: 'giftPopContent',
    props: ["curGiftList", "skuId"],
    components: {
        OnTheHour,
        GiveawayPopItem,
        OptionalGifts,
        BenefitGifts,
        NormalGifts,
        VipGifts
    },
    computed: {
        //41：常规赠品 42：会员加赠 43：整点加赠 44：仅赠券,45权益赠品
        popGiftList() {
            //处理数据，聚合可选赠品
            return this.curGiftList.reduce((result, giftItem) => {
                let group = result.findLast(item => item.giftType === giftItem.giftType);
                if (!group) {
                    group = { "giftType": giftItem.giftType, "optionalGiftId": giftItem.optionalGiftId, "opList": [], "normalList": [] };
                    result.push(group);
                }
                if (giftItem.optionalGiftId) {
                    if (giftItem.optionalGiftId != group.optionalGiftId){
                        group = { "giftType": giftItem.giftType, "optionalGiftId": giftItem.optionalGiftId, "opList": [...giftItem.list], "normalList": [] };
                        result.push(group);
                    }else group.opList.push(...giftItem.list);
                } else {
                    group.normalList.push(giftItem);
                }
                return result;
            }, []);
        }
    },
    methods: {
        handleGiftSelect(optionalGiftId, selectIdList) {
            this.$emit("handleGiftSelect", optionalGiftId, selectIdList)
        }
    }
}
</script>